import { Outlet } from "react-router-dom";
import { PageWrapper } from "./components/page-wrapper";
import { Sidebar } from "./components/sidebar";
import { useMenuItems, useSecondaryMenuItems } from "./layout.constants";
import styles from "./layout.module.scss";

export function AppLayout() {
  const menuItems = useMenuItems();
  const secondaryMenuItems = useSecondaryMenuItems();

  return (
    <div className={styles.layout} data-testid="app-layout">
      <Sidebar items={menuItems} secondaryItems={secondaryMenuItems} />
      <div className={styles.main}>
        <PageWrapper>
          <Outlet />
        </PageWrapper>
      </div>
    </div>
  );
}
